<div class="d-flex align-items-center rounded acm-promo-banner" *ngIf="isShowACMPromo()">
  <img src="/assets/images/acm/promo/dashboard/icon.webp" alt="" style="height: 100%; width: auto" />
  <div class="text-dark">
    <div class="font-weight-bold text-danger">You’re using only ~63% of your PMS potential.</div>
    <div>Discover powerful tools in AdvanceCM to automate operations and increase bookings.</div>
  </div>
  <div class="flex-fill"></div>
  <button
    class="btn btn-secondary bg-dark mr-3"
    (click)="onExploreACM()"
    style="border-radius: 5px"
    matTooltip="Explore AdvanceCM features"
  >
    <img src="/assets/images/acm/promo/blink.webp" height="13" alt="" />
    Explore
  </button>
</div>
